import { Box, HStack, Text } from '@skin-seoul/design-system';

import { useProductCard } from '../ProductCardContext';

import React from 'react';

import { isNil } from 'es-toolkit';
import { LucideIcon } from '../../LucideIcon';

const ProductCardInfoRating = () => {
  const { rating = 0, reviewCount = 0, theme = 'light' } = useProductCard();

  if (isNil(rating)) {
    return null;
  }

  if (rating > 0) {
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <HStack gap={1}>
          <Box display="flex" gap={1}>
            <LucideIcon name="Star" boxSize={4} fill="neutral.700" />
          </Box>
          <Text textStyle="paragraph.small" color={theme === 'dark' ? 'neutral.200' : 'neutral.700'}>
            {rating.toFixed(1)}
          </Text>
        </HStack>

        <Text textStyle="label.medium" fontWeight="regular" color={theme === 'dark' ? 'neutral.200' : 'neutral.400'}>
          ({reviewCount.toFixed(0)})
        </Text>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap="4px">
      <Text textStyle="paragraph.small" color={theme === 'dark' ? 'neutral.200' : 'neutral.400'}>
        &nbsp;
      </Text>
    </Box>
  );
};

export default ProductCardInfoRating;
